import script from "./Welcome.vue?vue&type=script&lang=ts&setup=true"
export * from "./Welcome.vue?vue&type=script&lang=ts&setup=true"

import "./Welcome.vue?vue&type=style&index=0&id=d31a262c&lang=less"

const __exports__ = script;

export default __exports__